import { useCallback } from 'react';

import { EMPTY_ARRAY } from '@e-socna/empty';
import type { PermissionEnum } from '@e-socna/data-layer';

import { useAuthenticationContext } from '../contexts/AuthenticationContext/hooks/useAuthenticationContext.hook';

// The permissions of the authenticated user, given by their roles: the screens
// ask for a permission, never for a role.
export const usePermissions = () => {
  const { authenticationData } = useAuthenticationContext();
  const permissions = authenticationData?.permissionCodes ?? EMPTY_ARRAY;

  const can = useCallback(
    (permission: PermissionEnum) => permissions.includes(permission),
    [permissions],
  );

  return { can };
};
